// extracted by mini-css-extract-plugin
export default {"navCol":"App_navCol__8dJcc"};